import { SelectionChangedEvent } from "ag-grid-community";
import { MasterFSPEntity } from "domain/entity/MasterFSP/MasterFSPEntity";
import _ from "lodash";
import { INITIAL_MASTER_FSP_COL_DEF, transferRowData } from "presentation/constant/MasterFSP/MasterFSPMaintenanceColumnDefinition";
import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { ConfirmDeleteModal } from "presentation/view/components/ConfirmDeleteModal";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Core } from "veronica-ui-component";
import { GroupButtons, Loader } from "veronica-ui-component/dist/component/core";


const MasterFSPTablePanel: React.FC = () => {
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const gridRef: any = useRef(null);
    const rightClickRef: any = createRef();
    const { selectedRows, isShowDeleteModal, isRejected, isRejectedCount, isPendingApproval, isPendingApprovalCount, searchStatus, isSearch, searchCriteria } = masterFSPState;
    const [anainfoState] = useANAInfoTracked();
    //const { chargeTypeDropdownOptions, subChargeTypeDropdownOptions } = masterFSPState.dynamicOptions;
    const { allowUpdate, operatingUnit, allowCreate, allowDelete } = anainfoState;
    const messageBarVM = useMessageBarVM();
    const [allRows, setAllRows] = useState<MasterFSPEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        // setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();

        masterFSPVM.updateSelectedRows(selectedRows);
    }, [masterFSPVM])

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);

    // useEffect(() => {
    //     if (!selectedRows || (selectedRows.length < 1)) {
    //         gridRef.current?.gridRef.current.api?.deselectAll();
    //     }
    // }, [selectedRows])

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("master-fsp-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked])

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(masterFSPState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [rightClickRef, masterFSPState.selectedRows, allowUpdate]);

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_MASTER_HOLD_COL_DEF?.slice());

    //     //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //     if (!onTableSelectionClicked) {
    //         gridRef.current?.gridRef.current.api?.deselectAll();
    //     }
    // })

    const handleAddClick = useCallback(() => {
        masterFSPVM.onAdd(/*chargeTypeDropdownOptions, subChargeTypeDropdownOptions, operatingUnit*/);
    }, [masterFSPVM])

    const handleRowDoubleClick = useCallback((entity: MasterFSPEntity) => {
        masterFSPVM.onEdit(entity, operatingUnit);
    }, [masterFSPVM, operatingUnit])

    const tbBtns = useMemo(() => {
        let btns = [];
        if (allowDelete) {
            btns.push({
                id: 'onDeleteButton',
                icon: 'Icon-trash',
                title: 'Delete'
            })
        }
        return btns;
    }, [allowDelete])

    const handleDelete = useCallback(() => {
        setIsLoading(true);
        setInitialAllRows(true);
        masterFSPVM.onCancelDelete();
        masterFSPVM.onDelete(selectedRows).then((data) => {
            if (data && data.success) {
                masterFSPVM.searchMasterFSP(masterFSPState.searchCriteria).then(() => {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Delete successfully.");
                }).catch((error) => {
                    setIsLoading(false)
                })
            } else {
                setIsLoading(false);
                messageBarVM.showError("Delete failed.");
            }
        }).catch((error) => {
            setIsLoading(false)
            messageBarVM.showError(error.message)
        })

    }, [masterFSPVM, messageBarVM, selectedRows, masterFSPState]);

    const handleCancel = useCallback(() => {
        masterFSPVM.onCancelDelete();
    }, [masterFSPVM])

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return masterFSPState.selectedRows;
    }, [masterFSPState.selectedRows]);

    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        masterFSPVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [masterFSPVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(masterFSPState.tableData);
        masterFSPVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [masterFSPState.tableData, masterFSPVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        masterFSPVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                masterFSPVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                masterFSPVM.searchMasterFSP(searchCriteria).then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    masterFSPVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    masterFSPVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [masterFSPVM, messageBarVM, searchCriteria]);

    const handleDeleteClick = useCallback(() => {
        if (selectedRows.length < 1) {
            messageBarVM.showError("Please select a record(s) to delete.");
            return;
        }
        if (selectedRows.map(x => x.status).includes("FINALIZED")) {
            messageBarVM.showError("Record status is FINALIZED, can not delete.");
            return;
        }
        if (selectedRows.map(x => x.status).includes("PROPOSED")) {
            messageBarVM.showError("Record status is PROPOSED, can not delete.");
            return;
        }
        masterFSPVM.onDeleteClick();
    }, [masterFSPVM, messageBarVM, selectedRows]);

    const handleGroupButtonClick = useCallback(async (buttonId: string) => {
        setIsLoading(true);
        if (searchStatus && buttonId === searchStatus) {
            await masterFSPVM.searchMasterFSP(searchCriteria).then((data) => {
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
            }).finally(() => {
                setIsLoading(false);
                setInitialAllRows(true);
            })
        } else {
            await masterFSPVM.onGroupButtonClick(buttonId).then((data) => {
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
            }).finally(() => {
                setIsLoading(false);
                setInitialAllRows(true);
            })
        }

    }, [searchStatus, masterFSPVM, searchCriteria]);

    const template = useMemo(() => {
        return (
            <>
                <Core.CheckButton
                    checked={isRejected}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
                    showBadge={true}
                    badgeValue={isRejectedCount > 999 ? '999+' : isRejectedCount}
                    disabled={isRejectedCount === 0}
                    size="medium"
                    inputId="isRejected"
                    label={MasterFSPMaintenanceConstant.REJECTED_BUT}
                />
                <Core.CheckButton
                    checked={isPendingApproval}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
                    showBadge={true}
                    badgeValue={isPendingApprovalCount > 999 ? '999+' : isPendingApprovalCount}
                    disabled={isPendingApprovalCount === 0}
                    size="medium"
                    inputId="isPendingApproval"
                    label={MasterFSPMaintenanceConstant.PENDING_APPROVAL_BUT}
                />
            </>
        )
    }, [handleGroupButtonClick, isPendingApproval, isPendingApprovalCount, isRejected, isRejectedCount])


    const memoTariffCodeTable = useMemo(() => {
        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" isMasterFsp={true} />}
                <div id="myDiv">
                    <NbisTable
                        id='master-fsp-table'
                        isNewColumnSetting={true}
                        columns={INITIAL_MASTER_FSP_COL_DEF?.slice()}
                        data={transferRowData(allRows) ?? []}
                        headerActionButtons={tbBtns}
                        showPaginator={false}
                        editable={false}
                        showHeaderIcons={true}
                        showAddIcon={allowCreate}
                        onAddClick={handleAddClick}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        isRowHighligted={true}
                        // onBodyScroll={(e: any) => changeCursor("master-fsp-table", getShowMoveCursor())}
                        showCutCursor={showMoveCursor}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: MasterFSPEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 130px)"
                        ref={gridRef}
                        onDeleteButton={handleDeleteClick}
                        headerLabel={
                            <GroupButtons
                                alignment="single-selection"
                                errorMessage=""
                                label=""
                                children={template}
                            />
                        }
                    />
                    <ConfirmDeleteModal headerText={MasterFSPMaintenanceConstant.TITLE}
                        contentText={`${MessageConstant.common.DELETE_ALERT_TITLE}\n${MessageConstant.common.DELETE_ALERT_MESSAGE}`}
                        visible={isShowDeleteModal}
                        onCancelClick={handleCancel}
                        onDeleteClick={handleDelete} />
                </div>
            </>
        );
    }, [allRows, handleAddClick, handleSelectionChange, handleRowDoubleClick, handleCancel, handleDelete, isShowDeleteModal, tbBtns, showMoveCursor, getSelectedRows, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, handleDeleteClick, allowUpdate, rightClickRef, template, allowCreate])

    useEffect(() => {
        setInitialAllRows(true);
    }, [isSearch]);

    useEffect(() => {
        if (initialAllRows) {
            if (masterFSPState.tableData && !_.isEmpty(masterFSPState.tableData)) {
                setAllRows(masterFSPState.tableData.map((masterFSPEntity, index) => ({
                    ...masterFSPEntity,
                    index: index ?? 0
                })));
            } else {
                setAllRows([]);
            }
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, masterFSPState.tableData]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoTariffCodeTable}
        {masterFSPState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(MasterFSPTablePanel);
